export const GET_ALL_ORG_REQUEST = "GET_ALL_ORG_REQUEST"
export const GET_ALL_ORG_SUCCESS = "GET_ALL_ORG_SUCCESS"
export const GET_ALL_ORG_FAIL = "GET_ALL_ORG_FAIL"